module.exports = __webpack_public_path__ + "media/images/spectrum-fa734bcc.png";